import { useCurrencyConversion } from "./hooks/useCurrencyConversion"
import { useMemo } from "react"
import { bucket } from "../../views/Dashboards/DashboardSalesAggregations"
import { useSelector } from "react-redux"
import { selectFilteredByExcludingTax } from "lib/store/services/analytics/selectors"

type Props = {
  product: bucket
  currencyCode: string
  ratesMap: Record<string, Record<string, number>>
}

export function ProductTotalSales({ product, currencyCode, ratesMap }: Props) {
  const filteredByExcludingTax = useSelector(selectFilteredByExcludingTax)

  const productCurrencyData = useMemo(() => {
    if (!product?.totalValuesPerCurrencyCode?.buckets) return []

    return product.totalValuesPerCurrencyCode.buckets.map((bucket) => {
      return {
        name: bucket.key,
        value: filteredByExcludingTax
          ? bucket.totalExcludingTax.value
          : bucket.totalIncludingTax.value
      }
    })
  }, [product])

  const { totalAmount: totalSales } = useCurrencyConversion(
    productCurrencyData,
    currencyCode,
    ratesMap,
    {
      skipMissingRates: true,
      onError: (error) => console.error("Conversion error:", error)
    }
  )

  const roundedValue = Math.round(totalSales?.toUnit() || 0)

  return roundedValue.toLocaleString()
}
